export default __webpack_public_path__ + "assets/images/eba1178f285a4c37f5fc269ebb6db8ae.jpg";